import React, { useMemo } from 'react';
import classNames from 'classnames';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import { Field, useField, useForm } from 'react-final-form';
import {
  DATA_ROOM_RFI_FILE_PERIOD,
  DATA_ROOM_RFI_FILE_TYPES_WITHOUT_PERIOD,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import SelectField from 'components/SelectField';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';

import './RfiDocumentField.styles.scss';

type RfiDocumentFieldProps = {
  className?: string;
  type: string;
  name: string;
  label: string;
};

const RfiDocumentField: React.FC<RfiDocumentFieldProps> = (props) => {
  const { name, label, className, type } = props;

  const { input } = useField(name);
  const { change } = useForm();

  const createSelectOptions = useCreateSelectOptions();

  const options = useMemo(
    () =>
      createSelectOptions(Object.values(DATA_ROOM_RFI_FILE_PERIOD).reverse()),
    [createSelectOptions],
  );

  const checked = input.value?.checked;

  const classes = classNames(
    'rfi-document-field',
    'clickable',
    { checked },
    className,
  );

  const withoutPeriod = DATA_ROOM_RFI_FILE_TYPES_WITHOUT_PERIOD.includes(type);

  return (
    <div
      className={classes}
      onClick={() => change(`${name}.checked`, !checked)}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <Field
          name={`${name}.checked`}
          type="checkbox"
          component={CheckboxField}
          label={label}
        />
      </div>

      {!withoutPeriod && (
        <div className="select-wrapper" onClick={(e) => e.stopPropagation()}>
          <Field
            component={SelectField}
            options={options}
            name={`${name}.period`}
          />
        </div>
      )}
    </div>
  );
};

export default RfiDocumentField;
